<div>
    <app-radio
        [value]="callbackData[0]?.arg[0]"
        [checked]="callbackData[1]?.arg ? callbackData[1].arg : false"
        (radioChange)="radioChanged($event)"
    ></app-radio>
</div>
